import React from 'react';
import logo from '../../images/logo.svg';

const Banquet = () => {

  return (
    <section className="landing">
        <div className="landing-inner transbox">
          <h1 className="x-large">
            <img className = "dtulogo" src={logo} alt="logo"/>
          </h1>
          <h1 className="x-large">FUTURE SCOPE</h1>
          <p className="lead" style={{color: 'black'}}>
            <i className='fa-light fa-construction'></i> Site in construction 
          </p>
        </div>
    </section>
  )
};

export default Banquet;